import Button from '@ui-kit/components/Button';
import { ModalActions } from '@ui-kit/components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import type { ModalProps } from '@/components/ModalRenderer/components/types';
import { Modal } from '@/components/ModalRenderer/Modal';
import { formatPercentage } from '@/localization/percentages';
import { DataList, DataListItem, DataListLabel, DataListValue } from '@/ui-kit/components/DataList';

type Props = ModalProps<{ monthlyRate: number }>;

const ConfirmReactivatePaymentProtectionInsurance = ({ payload, confirmAction }: Props) => {
  const { t } = useTranslation('Modal');

  return (
    <Modal title={t('ConfirmReactivatePaymentProtectionInsurance.title')}>
      <div className="flex flex-col gap-4">
        <p>{t('ConfirmReactivatePaymentProtectionInsurance.body')}</p>
        <DataList>
          <DataListItem>
            <DataListLabel>{t('ConfirmReactivatePaymentProtectionInsurance.monthlyCost')}</DataListLabel>
            <DataListValue>{formatPercentage(payload.monthlyRate, { decimals: 1 })}</DataListValue>
          </DataListItem>
        </DataList>
      </div>
      <ModalActions>
        <Button onClick={() => confirmAction?.()}>
          {t('ConfirmReactivatePaymentProtectionInsurance.button')}
        </Button>
      </ModalActions>
    </Modal>
  );
};

export default ConfirmReactivatePaymentProtectionInsurance;
